export default class Bead{
    color;

    /**
     * @param {Color} givenColor
     */
    constructor(givenColor) {
        this.color = givenColor;
    }
};